import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component({
  name: 'bpc-public-footer',
  components: {},
})
export default class PublicFooter extends Vue {
  @Prop(String) readonly publicFooter: string;

  get tenantAlias(): string {
    return this.$clientRouter.getTenantAlias();
  }

  /* Lifecycle hooks */

  // created() {}
  // updated() {}
  // destroyed() {}
}
